import React from 'react'
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon'

import { MeetingIcon } from './meeting'
import { UserManualIcon } from './user-manual-icon'
import { ConventionsIcon } from './conventions-icon'
import { CowoIcon } from './cowo-icon'
import { EventIcon } from './event'
import { DailyPassIcon } from './dailypass'
import { PlusCircleOutline } from 'mdi-material-ui'


export function BookMeetingRoomIcon(props: SvgIconProps): JSX.Element {
	return (
		<>
			<MeetingIcon {...props}/>
			{/* <SvgIcon className={"addBooking"}>
			</SvgIcon> */}
		</>
	)
}

export function BookMeetingEventIcon(props: SvgIconProps): JSX.Element {
	return (
		<>
			<EventIcon {...props}/>

			<SvgIcon className={"addBooking"}>
				<PlusCircleOutline></PlusCircleOutline>
			</SvgIcon>

		</>
	)
}

export function BookDailyPassIcon(props: SvgIconProps): JSX.Element {
	return (
		<>
			<DailyPassIcon {...props}/>

			{/* <SvgIcon className={"addBooking"}>
			</SvgIcon> */}

		</>
	)
}

export function UserManualShortcutIcon(props: SvgIconProps): JSX.Element {
	return (
		<>
			<UserManualIcon {...props}/>

			{/* <SvgIcon className={"addBooking"}>
			</SvgIcon> */}

		</>
	)
}
export function ConventionsShortcutIcon(props: SvgIconProps): JSX.Element {
	return (
		<>
			<ConventionsIcon {...props}/>


		</>
	)
}
export function CowoShortcutIcon(props: SvgIconProps): JSX.Element {
	return (
		<>
			<CowoIcon {...props}/>


		</>
	)
}
